import useAuth from "common/hooks/useAuth";
import useItem from "common/hooks/useItem";

import { useCallback, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import AlertsContext from "common/providers/alerts";
import UserForm from "./UserForm";

function MyAccountForm() {
  const { t } = useTranslation();
  const { setAlert } = useContext(AlertsContext);
  const { user: currentUser } = useAuth();

  const {
    saveItem,
    updateItem,
    item: myUserAccount,
    error,
    isFetching,
  }: any = useItem("users", currentUser?.id || 0, {
    populate: ["user", "user.role", "avatar"],
  });

  useEffect(() => {
    if (error) {
      setAlert(error, "danger");
    }
  }, [error, setAlert]);

  const onSubmit = useCallback(
    async (dataUser: any) => {
      const user = { ...dataUser };

      try {
        if (user.id) {
          await updateItem(user.id, user, false);
        } else {
          await saveItem(user, false);
        }
      } catch (e: any) {
        return e;
      }

      if (!error) {
        setAlert(t("common.saved"), "success");
      }
      return true;
    },
    [updateItem, saveItem, setAlert, error, t]
  );

  return isFetching && currentUser && !myUserAccount ? null : (
    <UserForm onSubmit={onSubmit} editedUser={myUserAccount} myAccount />
  );
}

export default MyAccountForm;
